import { em, math } from 'polished'
import styled from 'styled-components'

import TextField from 'components/_form/TextField'
import { TextFieldError } from 'components/_form/TextField/styles'
import ButtonRoundedSt from 'components/ButtonRoundedSt'
import { CartItemTitle } from 'styles/components/typography'

const closeButton = em(42)

export const Wrapper = styled.div`
  position: relative;
`

export const PromocodeAnimation = styled.div`
  transition: opacity ${p => p.theme.animation.timeStandard} ease-out;

  ${({ state }) =>
    state === 'entering' &&
    `
    position: absolute;
  `}

  ${({ state }) =>
    state === 'entered' &&
    `
    opacity: 1;
  `}

  ${({ state }) =>
    (state === 'entering' || state === 'exited' || state === 'exiting') &&
    `
    opacity: 0;
  `}

  ${({ state }) =>
    (state === 'entering' || state === 'exiting') &&
    `
    pointer-events: none;
  `}

  ${p => p.theme.mq.upMd} {
    ${({ state }) =>
      state === 'entering' &&
      `
      top: 0;
      left: 0;
    `}
  }
`

export const FormStyled = styled.form`
  margin-bottom: 0;
  margin-top: ${em(10)};

  ${p => p.theme.mq.upMd} {
    margin-top: 0;
  }
`

export const FormInner = styled.div`
  position: relative;
  display: flex;

  ${p => p.theme.mq.upMd} {
    align-items: center;
    display: block;
  }

  ${p => p.theme.mq.upLg} {
    display: flex;
  }
`

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  font-size: ${p => p.theme.typography.cartItemFontSize};
  margin-bottom: ${em(20)};
  margin-left: ${em(40)};

  & > label > span:nth-of-type(1) {
    white-space: nowrap;
  }

  // to show full error message
  & ${TextFieldError} {
    position: relative;
    height: auto;
    display: block;
    overflow: visible;
    margin-top: ${em(10)};
    color: ${p => p.theme.colors.materialRed};
  }

  ${p => p.theme.mq.upMd} {
    width: auto;
    max-width: ${p => em(164, p.theme.typography.fontSizeBasePx)};
    font-size: ${p => p.theme.typography.fontSize};
    margin-bottom: 0;
    margin-left: ${em(40)};
  }

  ${p => p.theme.mq.upLg} {
    max-width: ${p => em(171, p.theme.typography.fontSizeBasePx)};
    margin-left: 0;
    top: -${p => math(`${p.theme.typography.textSmallForms} / 2`)};

    & ${TextFieldError} {
      position: absolute;
    }
  }
`

export const TextFieldStyled = styled(TextField)`
  margin-bottom: ${em(7)};
  margin-top: -${em(6)};

  ${p => p.theme.mq.upMd} {
    margin-top: 0;
    margin-bottom: 0;
  }
`

export const ButtonWrapper = styled.div`
  width: auto;
  padding-left: ${em(20)};
  margin: 0;

  & > button {
    width: 100%;
  }

  ${p => p.theme.mq.upMd} {
    display: inline-block;
    padding-left: ${em(40)};
    margin-top: ${em(20)};
  }

  ${p => p.theme.mq.upLg} {
    display: block;
    padding-left: ${em(40)};
    margin-top: 0;
  }
`

export const CartItemTitleStyled = styled(CartItemTitle)`
  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.fontSize};
    line-height: ${p => p.theme.typography.cartItemFontLh};
  }
`

export const CartItemTitleButton = styled(CartItemTitleStyled)`
  display: inline-block;
  color: ${p => p.theme.colors.black};

  ${p => p.theme.mq.upMd} {
    padding: 0 ${p => em(25, p.theme.typography.fontSizeBasePx)};
  }
`

export const ButtonRoundedStStyled = styled(ButtonRoundedSt)`
  display: block;
  width: 100%;

  ${p => p.theme.mq.upMd} {
    width: auto;
  }
`

export const ButtonText = styled.span`
  display: block;
  padding: 0 ${em(20)};
`

export const IconBox = styled.div`
  display: inline-block;
  position: relative;
  top: ${em(5)};
  width: ${p => p.theme.blocks.iconInfoW};
  height: ${p => p.theme.blocks.iconInfoW};
  transform: rotateZ(0);
  transition: transform ${p => p.theme.animation.timeStandard} linear;
  -webkit-backface-visibility: hidden;

  ${p => p.theme.mq.hover} {
    &:hover {
      transform: rotateZ(180deg);
    }
  }

  ${p => p.theme.mq.upMd} {
    width: ${closeButton};
    height: ${closeButton};
  }

  ${p => p.theme.mq.upLg} {
    left: -${em(20)};
    width: ${closeButton};
    height: ${closeButton};
  }
`

export const CloseWrapper = styled.div`
  position: absolute;
  display: block;
  cursor: pointer;
  z-index: 30;
  left: 0;
  top: ${em(10)};
  margin-right: ${em(10)};
  line-height: ${p => p.theme.typography.inputLh};
  -webkit-backface-visibility: hidden;

  ${p => p.theme.mq.upMd} {
    left: -${em(5)};
    top: -${em(8)};
    margin-top: 0;
  }

  ${p => p.theme.mq.upLg} {
    left: -${em(33)};
    top: 0;
    margin-top: 0;
  }
`

export const StatusWrapper = styled.div`
  text-align: center;

  ${p => p.theme.mq.upMd} {
    display: block;
    max-width: ${em(245)};
    margin-bottom: ${em(3)};
    text-align: left;
  }
`

export const StatusIcon = styled.div`
  position: relative;
  line-height: 0;
  width: ${p => p.theme.blocks.iconInfoW};
  height: ${p => p.theme.blocks.iconInfoW};
  flex-shrink: 0;
  margin-right: auto;
  margin-left: auto;
  border-radius: 50%;
  background-color: ${p =>
    p.bgColor ? p.theme.colors[p.bgColor] : p.theme.colors.transparent};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    top: ${em(6)};
    left: ${p => math(`-${p.theme.blocks.iconInfoW} - ${em(10)}`)};
    margin-right: 0;
    margin-left: 0;
  }
`

export const ResetWrapper = styled.div`
  text-align: center;

  ${p => p.theme.mq.upMd} {
    text-align: left;
  }
`
